export const environment = {
  webApiUrl: "https://cnp-staging-api.maibec.com",
  production: false
};

